import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useEffect, useState, } from 'react';
import * as S from './styles';
import { useLongPressAction } from 'shared/hooks/ui/long-press';
import { show_toast } from 'console/dialogs/toast';
import { DeviceState } from 'console/shared/contexts/device/state/types';
import { useAction } from 'shared/hooks/redux/hooks';
export const ControlButton = memo(function ControlButton(props) {
    const { active, loading, onDisabledClick, disabled, onClick, children, color, background_color, style, fail, fail_message, data_tooltip, sx, } = props;
    const { online } = useContext(DeviceState);
    const onShowToast = useAction(show_toast);
    const onLoadingClick = useCallback(() => onShowToast('Невозможно выполнить действие'), []);
    const onOfflineClick = useCallback(() => onShowToast('Невозможно выполнить действие, устройство не на связи'), []);
    const onIncorrectClick = useCallback(() => {
        if (!online) {
            return onOfflineClick;
        }
        if (loading) {
            return onLoadingClick;
        }
        if (disabled) {
            return onDisabledClick ?? onLoadingClick;
        }
        return undefined;
    }, [loading, disabled, online]);
    const onLongPressEnd = useCallback(() => {
        const incorrect_action = onIncorrectClick();
        if (incorrect_action) {
            return incorrect_action();
        }
        navigator?.vibrate?.(300);
        return onClick();
    }, [onClick, onIncorrectClick]);
    const [show_fail, setShowFail] = useState(false);
    useEffect(() => {
        if (fail) {
            onShowToast(fail_message || 'Произошла ошибка');
            setShowFail(true);
            setTimeout(() => setShowFail(false), 2000);
        }
    }, [fail]);
    const long_press_handlers = useLongPressAction({
        active,
        onLongPressEnd,
        background_color,
        color,
        loading,
        fail: show_fail,
    });
    return (_jsx(S.ControlButton, { style: style, ...long_press_handlers, "data-tooltip": data_tooltip, tabIndex: -2, sx: sx, children: children }));
});
